module.exports = __webpack_public_path__ + "assets/7d42a9f51527e2cf7944e59612c1479a.png";